/* eslint-disable */
export default {
  namespaced: true,

  state: {
    ConoceDestinosESP: {
      icon1: "Cultura y gastronomía",
      icon2: "Qué ver y hacer",
      icon3: "Cuándo visitar",
      icon4: "Dónde quedarse",
      icon5: "Ubicación",
      icon6: "Consejos útiles"
    },
    ConoceDestinosENG: {
      icon1: "Culture and gastronomy",
      icon2: "The best thing to do",
      icon3: "Best time to visit",
      icon4: "Where should I stay?",
      icon5: "Location",
      icon6: "Tips"
    }
  },
  getters: {
    icon1(state, getters, rootState) {
      if (rootState.language == "es") {
        return state.ConoceDestinosESP.icon1;
      } else if (rootState.language == "en") {
        return state.ConoceDestinosENG.icon1;
      }
    },
    icon2(state, getters, rootState) {
      if (rootState.language == "es") {
        return state.ConoceDestinosESP.icon2;
      } else if (rootState.language == "en") {
        return state.ConoceDestinosENG.icon2;
      }
    },
    icon3(state, getters, rootState) {
      if (rootState.language == "es") {
        return state.ConoceDestinosESP.icon3;
      } else if (rootState.language == "en") {
        return state.ConoceDestinosENG.icon3;
      }
    },
    icon4(state, getters, rootState) {
      if (rootState.language == "es") {
        return state.ConoceDestinosESP.icon4;
      } else if (rootState.language == "en") {
        return state.ConoceDestinosENG.icon4;
      }
    },
    icon5(state, getters, rootState) {
      if (rootState.language == "es") {
        return state.ConoceDestinosESP.icon5;
      } else if (rootState.language == "en") {
        return state.ConoceDestinosENG.icon5;
      }
    },
    icon6(state, getters, rootState) {
      if (rootState.language == "es") {
        return state.ConoceDestinosESP.icon6;
      } else if (rootState.language == "en") {
        return state.ConoceDestinosENG.icon6;
      }
    }
  },
  mutations: {},
  actions: {}
};
